import { c as _c } from "react/compiler-runtime";
import "@fontsource/plus-jakarta-sans";
import type { AppProps } from "next/app";
import { UIProvider } from "@/utils/uiProvider";
import { MobileGate } from "@/components/layout/MobileGate";
export default function MyApp(t0) {
  const $ = _c(3);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] !== Component || $[1] !== pageProps) {
    t1 = <UIProvider><MobileGate><Component {...pageProps} /></MobileGate></UIProvider>;
    $[0] = Component;
    $[1] = pageProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}